"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InteractionController = exports.init = void 0;
var cryptoAES = require("crypto-js/aes");
var cryptoUtf8 = require("crypto-js/enc-utf8");
window.obfOptions = window.obfOptions || {};
// Defaults
var EnablePostPixel = false;
var VersionNumber = 1;
var PixelEndpoint = window.location.origin + '/interactions/pixel.gif';
var Debug = false;
var Application = null;
var Config = {
    id: '',
    params: {},
    version: VersionNumber,
    pageLoadOnce: false,
    pageCloseOnce: false,
    externalHost: {
        link: '',
        time: Number(),
    },
};
var queue;
function init(options) {
    EnablePostPixel = options.enablePostPixel;
    PixelEndpoint = options.pixelEndpoint;
    Application = options.application;
    Debug = options.debug;
    queue = new Queue();
    if (Debug) {
        console.log(options);
    }
}
exports.init = init;
var InteractionController = /** @class */ (function () {
    // private queue = [];
    function InteractionController(window, document) {
        this.task = {
            main: function (method, value, optional) {
                if (Debug) {
                    console.log(method, value, optional);
                }
                if (method === 'init') {
                    Config.id = value;
                }
                else if (method === 'param') {
                    Config.params[value] = function () { return optional; };
                }
                else if (method === 'event') {
                    if (value === 'view_page' && !Config.pageLoadOnce) {
                        Config.pageLoadOnce = true;
                        new Pixel(value, Helper.now(), optional);
                    }
                    else if (value !== 'view_page' && value !== 'close_page') {
                        new Pixel(value, Helper.now(), optional);
                    }
                }
            },
        };
        this.initInteractions(window, document);
        if (Debug) {
            console.log('Default Configuration:', PixelEndpoint, EnablePostPixel, Application, Debug);
        }
    }
    // public tag(method, value, optional?) {
    //   if (method === 'init') {
    //     Config.id = value;
    //   } else if (method === 'param') {
    //     Config.params[value] = () => optional;
    //   } else if (method === 'event') {
    //     if (value === 'view_page' && !Config.pageLoadOnce) {
    //       Config.pageLoadOnce = true;
    //       new Pixel(value, Helper.now(), optional);
    //     } else if (value !== 'view_page' && value !== 'close_page') {
    //       new Pixel(value, Helper.now(), optional);
    //     }
    //   }
    // }
    InteractionController.prototype.tag = function (method, value, optional) {
        queue.addQueueItemForTopic(this.task, 'send', method, value, optional);
    };
    InteractionController.prototype.initInteractions = function (window, document) {
        var _this = this;
        var _a, _b;
        // update the cookie if it exists, if it doesn't, create a new one, lasting 2 years
        if (Cookie.exists('uid') && LocalStorage.exists('uid')) {
            Cookie.set('uid', Cookie.get('uid'), 2 * 365 * 24 * 60);
            LocalStorage.set('uid', LocalStorage.get('uid'));
        }
        else {
            null;
            //Cookie.set('uid', Helper.guid(), 2 * 365 * 24 * 60);
        }
        if (!Cookie.exists('uid') && false) {
            var url = PixelEndpoint;
            var application = Application;
            var vsid = null;
            var xhr_1 = new XMLHttpRequest();
            xhr_1.open('POST', url, true);
            xhr_1.setRequestHeader('Content-type', 'application/json; charset=UTF-8');
            xhr_1.setRequestHeader('X-Application', application);
            var data = {
                event: 'view_page',
                full_url: window.location.href,
                transaction_id: null,
                source: null,
                source_data: null
            };
            xhr_1.addEventListener('load', function () {
                var _a, _b;
                if (Debug) {
                    console.log(this.responseText);
                }
                try {
                    var response = JSON.parse(this.responseText);
                    vsid = ((_a = response === null || response === void 0 ? void 0 : response.meta) === null || _a === void 0 ? void 0 : _a.vsid) ? (_b = response === null || response === void 0 ? void 0 : response.meta) === null || _b === void 0 ? void 0 : _b.vsid : false;
                    Cookie.set('uid', vsid, 2 * 365 * 24 * 60);
                    LocalStorage.set('uid', vsid);
                }
                catch (error) {
                }
            });
            xhr_1.send(JSON.stringify(data));
            xhr_1.onload = function () {
                if (xhr_1.status === 201) {
                    if (Debug) {
                        console.log('Post successfully created!');
                    }
                }
            };
        }
        // save any utms through as session cookies
        Cookie.setUtms();
        // // process the queue and future incoming commands
        // this.tag = (method, value, optional) => {
        //   if (method === 'init') {
        //     Config.id = value;
        //   } else if (method === 'param') {
        //     Config.params[value] = () => optional;
        //   } else if (method === 'event') {
        //     if (value === 'view_page' && !Config.pageLoadOnce) {
        //       Config.pageLoadOnce = true;
        //       new Pixel(value, Helper.now(), optional);
        //     } else if (value !== 'view_page' && value !== 'close_page') {
        //       new Pixel(value, Helper.now(), optional);
        //     }
        //   }
        // };
        // // run the queued calls from the snippet to be processed
        // for (var i = 0, l = this.queue.length; i < l; i++) {
        //   this.tag.apply(this.tag, this.queue[i]);
        // }
        // process the queue and future incoming commands first init
        this.tag = function (method, value, optional) {
            var _a, _b;
            queue.addQueueItemForTopic(_this.task, 'send', method, value, optional);
            // run the queued calls from the snippet to be processed
            if (((_b = (_a = queue === null || queue === void 0 ? void 0 : queue.queueItems) === null || _a === void 0 ? void 0 : _a.send) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                queue.processItemsForQueueTopic('send');
            }
        };
        // run the queued calls from the snippet to be processed
        if (((_b = (_a = queue === null || queue === void 0 ? void 0 : queue.queueItems) === null || _a === void 0 ? void 0 : _a.send) === null || _b === void 0 ? void 0 : _b.length) > 0) {
            queue.processItemsForQueueTopic('send');
        }
        // https://github.com/GoogleChromeLabs/page-lifecycle/blob/master/src/Lifecycle.mjs
        // Safari does not reliably fire the `pagehide` or `visibilitychange`
        var isSafari = null;
        var ua = navigator.userAgent.toLowerCase();
        if (ua.indexOf('safari') != -1) {
            if (ua.indexOf('chrome') > -1) {
                isSafari = false; // Chrome
            }
            else {
                isSafari = true; // Safari
            }
        }
        var isPageHideSupported = 'onpageshow' in self;
        // IE9-10 do not support the pagehide event, so we fall back to unload
        // pagehide event is more reliable but less broad than unload event for mobile and modern browsers
        var pageCloseEvent = isPageHideSupported && !isSafari ? 'pagehide' : 'unload';
        window.addEventListener(pageCloseEvent, function () {
            if (!Config.pageCloseOnce) {
                Config.pageCloseOnce = true;
                new Pixel('close_page', Helper.now(), function () {
                    // if a link was clicked in the last 5 seconds that goes to an external host, pass it through as event data
                    if (Helper.isPresent(Config.externalHost) &&
                        Helper.now() - Number(Config.externalHost.time) < 5 * 1000) {
                        return Config.externalHost.link;
                    }
                });
            }
        });
        window.onload = function () {
            // Get all OBF tagged components
            var dataElementAttributes = {
                custom: 'data-sosint-event',
                // custom data atribute to track
                obf_button: 'data-book-btn',
                // booking form button or link element with attribute
                obf_button_link: 'href*="#open-booking-form"',
                // booking form button or link element with attribute document.querySelectorAll('[href="#open-booking-form"]');
                obf_search: 'book-search-container',
                // booking form search element
                obf_account_menu: 'data-menu-layout',
            };
            var aTags = document.getElementsByTagName('a');
            for (var i = 0, l = aTags.length; i < l; i++) {
                aTags[i].addEventListener('click', function (_e) {
                    if (Url.externalHost(this)) {
                        Config.externalHost = {
                            link: this.href,
                            time: Helper.now(),
                        };
                    }
                }.bind(aTags[i]));
            }
            var _loop_1 = function (element) {
                dataAttributes = document.querySelectorAll('[' + dataElementAttributes[element] + ']');
                for (var i = 0, l = dataAttributes.length; i < l; i++) {
                    dataAttributes[i].addEventListener('click', function (_e) {
                        switch (element) {
                            // Booking form elements
                            case 'obf_button':
                            case 'obf_button_link':
                            case 'obf_search':
                            case 'obf_account_menu':
                                var eventData = null;
                                eventData = this.getAttribute('data-sosint-data');
                                // If eventData is not set, get the Class description for the element
                                if (!eventData) {
                                    // Get element class(es)
                                    var elementClass = this.className;
                                    // If element has class(es)
                                    if (elementClass !== '') {
                                        eventData = elementClass;
                                    }
                                }
                                new Pixel(element, Helper.now(), eventData);
                                break;
                            // Default custom element
                            default:
                                var event = this.getAttribute(dataElementAttributes[element]);
                                if (event) {
                                    new Pixel(event, Helper.now(), this.getAttribute('data-sosint-data'));
                                }
                                break;
                        }
                    }.bind(dataAttributes[i]));
                }
            };
            var dataAttributes;
            for (var element in dataElementAttributes) {
                _loop_1(element);
            }
        };
    };
    return InteractionController;
}());
exports.InteractionController = InteractionController;
var Queue = /** @class */ (function () {
    function Queue() {
        this.queueItems = {};
    }
    Queue.prototype.addQueueItemForTopic = function (queueItem, topic, method, value, optional) {
        if (this.queueItems[topic] === undefined) {
            this.queueItems[topic] = [{ queueItem: queueItem, method: method, value: value, optional: optional }];
        }
        else {
            this.queueItems[topic].push({ queueItem: queueItem, method: method, value: value, optional: optional });
        }
    };
    Queue.prototype.processItemsForQueueTopic = function (topic) {
        for (var _i = 0, _a = queue.queueItems[topic]; _i < _a.length; _i++) {
            var item = _a[_i];
            if (item === null || item === void 0 ? void 0 : item.queueItem)
                item.queueItem.main(item.method, item.value, item.optional);
        }
        this.queueItems[topic] = [];
        var numberOfItemsLeft = this.queueItems[topic].length;
        if (numberOfItemsLeft > 0) {
            if (Debug) {
                console.log('Number of items left in Queue for topic' + topic, this.queueItems[topic].length);
            }
        }
        else {
            if (Debug) {
                console.log('No more tasks for topic ' + topic);
            }
        }
    };
    return Queue;
}());
var Helper = /** @class */ (function () {
    function Helper() {
    }
    Helper.isPresent = function (variable) {
        return (typeof variable !== 'undefined' && variable !== null && variable !== '');
    };
    Helper.now = function () {
        return 1 * Number(new Date());
    };
    // static guid() {
    //   return Config.version + '-xxxxxxxx-'.replace(/[x]/g, function(c) {
    //       var r = Math.random()*36|0, v = c == 'x' ? r : (r&0x3|0x8);
    //       return v.toString(36);
    //   }) + (1 * new Date()).toString(36);
    // }
    Helper.guid = function () {
        return ('xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx'.replace(/[x]/g, function (c) {
            var r = (Math.random() * 36) | 0, v = c == 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(36);
        }) + (1 * Number(new Date())).toString(36));
    };
    Helper.prototype.getVsid = function () {
        var url = PixelEndpoint;
        var application = Application;
        var vsid = null;
        var xhr = new XMLHttpRequest();
        xhr.open('POST', url, true);
        xhr.setRequestHeader('Content-type', 'application/json; charset=UTF-8');
        xhr.setRequestHeader('X-Application', application);
        var data = {
            event: 'get_vsid',
            full_url: window.location.href,
            transaction_id: null,
            source: null,
            source_data: null
        };
        xhr.addEventListener('load', function () {
            var _a, _b;
            if (Debug) {
                console.log(this.responseText);
            }
            try {
                var response = JSON.parse(this.responseText);
                vsid = ((_a = response === null || response === void 0 ? void 0 : response.meta) === null || _a === void 0 ? void 0 : _a.vsid) ? (_b = response === null || response === void 0 ? void 0 : response.meta) === null || _b === void 0 ? void 0 : _b.vsid : false;
                return vsid;
            }
            catch (error) {
                return false;
            }
        });
        xhr.send(JSON.stringify(data));
        xhr.onload = function () {
            if (xhr.status === 201) {
                if (Debug) {
                    console.log('Post successfully created!');
                }
            }
            else {
                return false;
            }
        };
    };
    // reduces all optional data down to a string
    Helper.optionalData = function (data) {
        if (Helper.isPresent(data) === false) {
            return '';
        }
        else if (typeof data === 'object') {
            // runs Helper.optionalData again to reduce to string in case something else was returned
            return Helper.optionalData(JSON.stringify(data));
        }
        else if (typeof data === 'function') {
            // runs the function and calls Helper.optionalData again to reduce further if it isn't a string
            return Helper.optionalData(data());
        }
        else {
            return String(data);
        }
    };
    return Helper;
}());
var Browser = /** @class */ (function () {
    function Browser() {
    }
    Browser.nameAndVersion = function () {
        var ua = navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (/trident/i.test(M[1])) {
            tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
            return 'IE ' + (tem[1] || '');
        }
        if (M[1] === 'Chrome') {
            tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
            if (tem != null)
                return tem.slice(1).join(' ').replace('OPR', 'Opera');
        }
        M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
        if ((tem = ua.match(/version\/(\d+)/i)) != null)
            M.splice(1, 1, tem[1]);
        return M.join(' ');
    };
    Browser.isMobile = function () {
        return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    };
    Browser.userAgent = function () {
        return window.navigator.userAgent;
    };
    return Browser;
}());
var Cookie = /** @class */ (function () {
    function Cookie() {
    }
    Cookie.prefix = function () {
        return "__" + 'sosint' + "_";
    };
    Cookie.set = function (name, value, minutes, path) {
        if (path === void 0) { path = '/'; }
        var expires = '';
        if (Helper.isPresent(minutes)) {
            var date = new Date();
            date.setTime(date.getTime() + minutes * 60 * 1000);
            expires = "expires=" + date['toGMTString']() + "; ";
        }
        document.cookie = "" + this.prefix() + name + "=" + value + "; " + expires + "path=" + path + "; SameSite=Lax";
    };
    Cookie.get = function (name) {
        name = "" + this.prefix() + name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ')
                c = c.substring(1);
            if (c.indexOf(name) == 0)
                return c.substring(name.length, c.length);
        }
        return;
    };
    Cookie.getValue = function (name) {
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ')
                c = c.substring(1);
            if (c.indexOf(name) == 0)
                return c.substring(name.length, c.length);
        }
        return;
    };
    Cookie.delete = function (name) {
        this.set(name, '', -100);
    };
    Cookie.exists = function (name) {
        return Helper.isPresent(this.get(name));
    };
    Cookie.setUtms = function () {
        var utmArray = [
            'utm_source',
            'utm_medium',
            'utm_term',
            'utm_content',
            'utm_campaign',
            'utm_source_platform',
            'utm_creative_format',
            'utm_marketing_tactic',
        ];
        var exists = false;
        for (var i = 0, l = utmArray.length; i < l; i++) {
            if (Helper.isPresent(Url.getParameterByName(utmArray[i], window.location.href))) {
                exists = true;
                break;
            }
        }
        if (exists) {
            var val, save = {};
            for (var i = 0, l = utmArray.length; i < l; i++) {
                val = Url.getParameterByName(utmArray[i], window.location.href);
                if (Helper.isPresent(val)) {
                    save[utmArray[i]] = val;
                }
            }
            this.set('utm', JSON.stringify(save), 24 * 60 * 60 * 1000);
        }
    };
    Cookie.getUtm = function (name) {
        if (this.exists('utm')) {
            var utms = JSON.parse(this.get('utm'));
            return name in utms ? utms[name] : '';
        }
    };
    return Cookie;
}());
var LocalStorage = /** @class */ (function () {
    function LocalStorage() {
    }
    LocalStorage.prefix = function () {
        return "__" + 'sosint' + "_";
    };
    LocalStorage.set = function (name, value) {
        try {
            localStorage.setItem("" + this.prefix() + name, value);
        }
        catch (e) {
            //..
        }
    };
    LocalStorage.get = function (name) {
        name = "" + this.prefix() + name;
        var localStorageValue;
        try {
            localStorageValue = localStorage.getItem(name);
        }
        catch (e) {
            //..
        }
        return localStorageValue;
    };
    LocalStorage.getValue = function (name) {
        var localStorageValue;
        try {
            localStorageValue = localStorage.getItem(name);
        }
        catch (e) {
            //..
        }
        return localStorageValue;
    };
    LocalStorage.delete = function (name) {
        try {
            localStorage.removeItem(name);
        }
        catch (e) {
            //..
        }
    };
    LocalStorage.exists = function (name) {
        try {
            return localStorage.getItem(name) !== null ? true : false;
        }
        catch (e) {
            return false;
        }
    };
    return LocalStorage;
}());
var Url = /** @class */ (function () {
    function Url() {
    }
    // http://stackoverflow.com/a/901144/1231563
    Url.getParameterByName = function (name, url) {
        if (!url)
            url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)', 'i'), results = regex.exec(url);
        if (!results)
            return null;
        if (!results[2])
            return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    };
    Url.externalHost = function (link) {
        return (link.hostname != location.hostname && link.protocol.indexOf('http') === 0);
    };
    return Url;
}());
var Pixel = /** @class */ (function () {
    function Pixel(event, timestamp, optional) {
        this.params = [];
        this.event = event;
        this.timestamp = timestamp;
        this.optional = Helper.optionalData(optional);
        this.buildParams();
        if (EnablePostPixel) {
            this.send();
        }
        else {
            this.sendWithAPI();
        }
    }
    Pixel.prototype.buildParams = function () {
        var attr = this.getAttribute();
        for (var index in attr) {
            if (attr.hasOwnProperty(index)) {
                this.setParam(index, attr[index](index));
            }
        }
    };
    Pixel.prototype.getAttribute = function () {
        var _this = this;
        return __assign({ id: function () { return Config.id; }, 
            // website Id
            uid: function () { return Cookie.get('uid') || LocalStorage.get('uid'); }, 
            // user Id
            csid: function () { return Cookie.getValue('user-login') || LocalStorage.getValue('user-login'); }, 
            // Get source phone
            ss: function () { var _a; return (_a = window === null || window === void 0 ? void 0 : window.obfOptions) === null || _a === void 0 ? void 0 : _a.phone; }, 
            // Get source phone
            sd: function () { var _a, _b; return JSON.stringify([{ 'id': Cookie.getValue('campaign_id') || LocalStorage.getValue('campaign_id'), 'abbr': Cookie.getValue('campaign_abbr') || LocalStorage.getValue('campaign_abbr'), 'phone': (_a = window === null || window === void 0 ? void 0 : window.obfOptions) === null || _a === void 0 ? void 0 : _a.phone, 'domain_url': (_b = window === null || window === void 0 ? void 0 : window.obfOptions) === null || _b === void 0 ? void 0 : _b.main_url }]); }, 
            // get user_login cookie
            ev: function () { return _this.event; }, 
            // event being triggered
            ed: function () { return _this.optional; }, 
            // any event data to pass along
            v: function () { return Config.version; }, 
            // openpixel.js version
            dl: function () { return window.location.href; }, 
            // document location
            rl: function () { return document.referrer; }, 
            // referrer location
            ts: function () { return _this.timestamp; }, 
            // timestamp when event was triggered
            de: function () { return document.characterSet; }, 
            // document encoding
            sr: function () { return window.screen.width + 'x' + window.screen.height; }, 
            // screen resolution
            vp: function () { return window.innerWidth + 'x' + window.innerHeight; }, 
            // viewport size
            cd: function () { return window.screen.colorDepth; }, 
            // color depth
            dt: function () { return document.title; }, 
            // document title
            bn: function () { return Browser.nameAndVersion(); }, 
            // browser name and version number
            md: function () { return Browser.isMobile(); }, 
            // is a mobile device?
            ua: function () { return Browser.userAgent(); }, 
            // user agent
            tz: function () { return new Date().getTimezoneOffset(); }, 
            // timezone
            utm_source: function (key) { return Cookie.getUtm(key); }, 
            // get the utm source
            utm_medium: function (key) { return Cookie.getUtm(key); }, 
            // get the utm medium
            utm_term: function (key) { return Cookie.getUtm(key); }, 
            // get the utm term
            utm_content: function (key) { return Cookie.getUtm(key); }, 
            // get the utm content
            utm_campaign: function (key) { return Cookie.getUtm(key); }, 
            // get the utm campaign
            utm_source_platform: function (key) { return Cookie.getUtm(key); }, 
            // get the utm source platform
            utm_creative_format: function (key) { return Cookie.getUtm(key); }, 
            // get the utm creative format
            utm_marketing_tactic: function (key) { return Cookie.getUtm(key); } }, Config.params);
    };
    Pixel.prototype.setParam = function (key, val) {
        if (Helper.isPresent(val)) {
            this.params.push(key + "=" + encodeURIComponent(val));
        }
        else {
            this.params.push(key + "=");
        }
    };
    Pixel.prototype.send = function () {
        window.navigator.sendBeacon ? this.sendBeacon() : this.sendImage();
    };
    Pixel.prototype.sendBeacon = function () {
        window.navigator.sendBeacon(this.getSourceUrl());
    };
    Pixel.prototype.sendImage = function () {
        this.img = document.createElement('img');
        this.img.src = this.getSourceUrl();
        this.img.style.display = 'none';
        this.img.width = '1';
        this.img.height = '1';
        document.getElementsByTagName('body')[0].appendChild(this.img);
    };
    Pixel.prototype.getSourceUrl = function () {
        return PixelEndpoint + "?" + this.params.join('&');
    };
    Pixel.prototype.sendWithAPI = function () {
        var _a;
        var url = PixelEndpoint; //"https://dev.fantasticxrm.com/api/v2/system/interactions";
        var application = Application;
        var dataElementAttributes = [
            'obf_button',
            'obf_button_link',
            'obf_search',
            'obf_account_menu',
        ];
        if (((_a = this.params) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var objParams = {};
            var source = null;
            var main_url = null;
            var source_data = null;
            var transaction_id = null;
            // Build the json object from params
            this.params.forEach(function (element) {
                var key_value = element.split('=');
                try {
                    objParams[key_value[0]] = decodeURIComponent(decodeURIComponent(key_value[1]));
                }
                catch (e) {
                    // var fix_encoded = key_value[1].replace(/%([^\d].)/, "%25$1");
                    //  objParams[key_value[0]] = decodeURIComponent(
                    //   decodeURIComponent(fix_encoded)
                    // );
                    console.log('debug:', key_value[1]);
                }
            });
            var par_id = objParams['id'];
            var par_event = objParams['ev'];
            var par_source = objParams['ss'] ? objParams['ss'] : null;
            var par_source_data = objParams['sd'] !== '[{}]' ? JSON.parse(objParams['sd'])[0] : {};
            // Remove '=' symbol from source date object values
            if (par_source_data && Object.keys(par_source_data).length !== 0) {
                for (var key in par_source_data) {
                    if (par_source_data[key] && par_source_data[key][0] === '=') {
                        par_source_data[key] = par_source_data[key].substring(1);
                    }
                }
            }
            var par_vsid = objParams['uid'] ? objParams['uid'] : null;
            var par_csid = objParams['csid'];
            var par_payload = objParams['ed'];
            var par_fullurl = objParams['dl'];
            // Page title
            var page_title = objParams['dt'];
            // time_stamp
            var time_stamp = objParams['ts'];
            // Time zone
            var time_zone = objParams['tz'];
            // Browser Name
            var browser_name = objParams['bn'];
            if (Debug) {
                console.log('Incoming properties: ', objParams);
            }
            if (par_id) {
                var xhr_2 = new XMLHttpRequest();
                xhr_2.open('POST', url, true);
                xhr_2.setRequestHeader('Content-type', 'application/json; charset=UTF-8');
                xhr_2.setRequestHeader('X-Application', application);
                if (par_vsid) {
                    xhr_2.setRequestHeader('X-Vsid', par_vsid);
                }
                // If user is logged add in the header CSID
                if (par_csid) {
                    // Remove from the token the first element wiht the "="
                    par_csid = par_csid.substring(1);
                    par_csid = this.decryptData(par_csid, 'LMrofhHejiTWJeRYuVI6wV4cPmcb7H7u1nQg1M3UW8g'); //TODO hardcoded key
                    xhr_2.setRequestHeader('Authorization', par_csid);
                }
                // Parse payload property to jsons if its object
                if (par_payload !== null) {
                    try {
                        par_payload = JSON.parse(par_payload);
                        if (typeof par_payload === 'object') {
                        }
                    }
                    catch (error) {
                        if (Debug) {
                            console.warn('Payload is not an object!');
                        }
                    }
                }
                // Set one event for all elements
                if (dataElementAttributes.indexOf(par_event) !== -1) {
                    var obf_el_attributes = par_payload;
                    par_payload = {};
                    par_payload['clicked_element_attributes'] = obf_el_attributes;
                    par_payload['clicked_element'] = par_event;
                    par_event = 'open_booking_form_click';
                }
                if (par_payload) {
                    // Get the source from the payload if exist
                    source = (par_payload === null || par_payload === void 0 ? void 0 : par_payload.source) ? par_payload === null || par_payload === void 0 ? void 0 : par_payload.source : null;
                    main_url = (par_payload === null || par_payload === void 0 ? void 0 : par_payload.main_url) ? par_payload === null || par_payload === void 0 ? void 0 : par_payload.main_url : null;
                    // Remove form the original payload
                    delete par_payload['source'];
                    delete par_payload['main_url'];
                    // obf interactions are with id-obf-hostname the web are with id-web-hostname
                    par_fullurl = (par_payload === null || par_payload === void 0 ? void 0 : par_payload.iframe_full_url) ? par_payload === null || par_payload === void 0 ? void 0 : par_payload.iframe_full_url : par_fullurl;
                    // Remove form the original payload
                    delete par_payload['iframe_full_url'];
                    transaction_id = (par_payload === null || par_payload === void 0 ? void 0 : par_payload.transaction_id) ? par_payload === null || par_payload === void 0 ? void 0 : par_payload.transaction_id : transaction_id;
                    // Remove form the original payload
                    delete par_payload['transaction_id'];
                    // Add aditinal properties in the payload
                    par_payload['page_title'] = page_title;
                    par_payload['time_stamp'] = time_stamp;
                    par_payload['time_zone'] = time_zone;
                    par_payload['browser_name'] = browser_name;
                }
                var source_data = Object.keys(par_source_data).length !== 0 ? par_source_data : {};
                source_data.phone = (source_data === null || source_data === void 0 ? void 0 : source_data.phone) ? source_data.phone : source,
                    source_data.domain_url = (source_data === null || source_data === void 0 ? void 0 : source_data.domain_url) ? source_data.domain_url : main_url;
                var data = {
                    event: par_event,
                    full_url: par_fullurl,
                    transaction_id: transaction_id,
                    source: source ? source : par_source,
                    source_data: source_data ? source_data : null
                };
                if (par_payload) {
                    data['payload'] = par_payload;
                }
                if (Debug) {
                    console.log('Send interaction data: ', data);
                }
                xhr_2.addEventListener('load', function () {
                    var _a, _b;
                    if (Debug) {
                        console.log(this.responseText);
                    }
                    try {
                        // if(!par_vsid) {
                        var response = JSON.parse(this.responseText);
                        var vsid = ((_a = response === null || response === void 0 ? void 0 : response.meta) === null || _a === void 0 ? void 0 : _a.vsid) ? (_b = response === null || response === void 0 ? void 0 : response.meta) === null || _b === void 0 ? void 0 : _b.vsid : null;
                        if (vsid) {
                            Cookie.set('uid', vsid, 2 * 365 * 24 * 60);
                            LocalStorage.set('uid', vsid);
                        }
                        // }
                    }
                    catch (error) {
                        return false;
                    }
                });
                xhr_2.send(JSON.stringify(data));
                xhr_2.onload = function () {
                    if (xhr_2.status === 201) {
                        if (Debug) {
                            console.log("Post successfully created!");
                        }
                    }
                };
            }
            else {
                console.warn('Missing initial "init" event with id! Example: tag("init", "id-web-localhost")');
            }
        }
    };
    /**
     * @param {any} data
     * @param {string} key
     */
    Pixel.prototype.decryptData = function (data, key) {
        var decryptedData = cryptoAES.decrypt(data.toString(), key);
        var plaintext = '';
        try {
            plaintext = JSON.parse(decryptedData.toString(cryptoUtf8));
        }
        catch (err) {
            plaintext = decryptedData.toString(cryptoUtf8);
        }
        return plaintext;
    };
    return Pixel;
}());
